var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('v-layout',{attrs:{"wrap":"","row":""}},[_c('v-flex',{attrs:{"md12":"","xs12":""}},[_c('h5',{staticClass:"primary--text text-center"},[_vm._v(" "+_vm._s(this.$route.params.message || this.message)+" ")])])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }